module.exports = __webpack_public_path__ + "static/media/girl-with-grass.00c74358.jpg";